import { useState, useEffect, useCallback } from 'react';
import useDebounce from '../../context/hooks/useDebounce';
import { Table, Form, InputGroup, Row, Col, Spinner } from 'react-bootstrap';
import ListPaginator from '../../components/ListPaginator';
import { useNavigate } from 'react-router-dom';
import useAxiosPrivate from '../../context/hooks/useAxiosPrivate';
import ExcelProducts from './ExcelProducts';
import '../../appstyles/ClientsCSS/ClientsList.css';

const ProductsList = () => {
  const axiosInstance = useAxiosPrivate();
  const [products, setProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 700);
  const [loading, setLoading] = useState(false)
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();

  const fetchProducts = useCallback((page, searchQuery, pageSize) => {
    setLoading(true)
    const url = searchQuery
      ? `api/product/?page=${page}&size=${pageSize}&product_name=${searchQuery}`
      : `api/product/?page=${page}&size=${pageSize}`;

    axiosInstance.get(url)
      .then(response => {
        setProducts(response.data);
        setTotalPages(response.data.totalPages);
      })
      .catch(error => {
        console.error('Failed to fetch products', error);
      }).finally(() => {
        setLoading(false);
      });
  }, [axiosInstance]);

  useEffect(() => {
    fetchProducts(currentPage, debouncedSearch, rowsPerPage);
  }, [currentPage, debouncedSearch, rowsPerPage, fetchProducts]);

  const handleRowClick = (productId) => {
    navigate(`/products/details/${productId}`);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  return (
    <div className='maestros-list'>
      <h2>Lista de Productos</h2>
      <hr />
      <Form inline style={{ width: '50%' }} onSubmit={(e) => e.preventDefault()}>
        <InputGroup>
          <Form.Control
            type="search"
            placeholder="Buscar por nombre de producto"            
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          >
          </Form.Control>
        </InputGroup>
      </Form>

      {loading ? ( 
        <div className='loading-container'>
        <p style={{fontFamily: 'Roboto, sans-serif'}}>Cargando...</p>
        <Spinner animation="border" variant="info" style={{width: '4.5rem', height: '4.5rem'}} />
        </div>
      ) : (
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>ID</th>
            <th>Nombre Producto</th>
            <th>Fabricante</th>
            <th>Categoría</th>
            <th>Subcategoría</th>
          </tr>
        </thead>
        <tbody>
          {products.data && products.data.map(product => (
            <tr key={product.product_id} onClick={() => handleRowClick(product.product_id)} style={{ cursor: 'pointer' }}>
              <td>{product.product_id}</td>
              <td>{product.product_name}</td>
              <td>{product.manufacturer}</td>
              <td>{product.product_category}</td>
              <td>{product.product_subcategory}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      )}

      <Row>
      <Col
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <ExcelProducts/>
      </Col>
      <Col>
        <ListPaginator
          currentPage={currentPage}
          totalPages={totalPages}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={value => {
            setRowsPerPage(value);
            setCurrentPage(1);
          }}
        />
      </Col>
    </Row> 
    </div>
  );
};

export default ProductsList;
